import differenceWith from 'lodash/differenceWith';
import { observable, computed } from 'mobx';
import { PlayerStore } from 'modules/player';

import { DEFAULT_ZOOM } from './constants';

const DEFAULT_REFERENCE_LINE_POSITION = 0.5;

class SubtitleStore {
  @observable zoom = DEFAULT_ZOOM;
  @observable scrollPosition = 0;
  @observable referenceLinePosition = DEFAULT_REFERENCE_LINE_POSITION;

  @observable subtitles = {};
  @observable cues = [];
  @observable _supportedTranscriptionLangs = [];

  @observable languageCode = '';

  @observable currentCue = {};
  @observable duration = 0;
  @observable status = '';

  @computed
  get supportedLangs() {
    const supportedLangs = {};

    Object.keys(this.subtitles).forEach((code) => {
      supportedLangs[code] = this.excludeExistentLanguages(
        PlayerStore.supportedLangs,
        this.subtitles[code]
      );
    });

    return supportedLangs;
  }

  @computed
  get supportedTranscriptionLangs() {
    const supportedLangs = {};

    Object.keys(this.subtitles).forEach((code) => {
      supportedLangs[code] = this.excludeExistentLanguages(
        this._supportedTranscriptionLangs,
        this.subtitles[code]
      );
    });

    return supportedLangs;
  }

  excludeExistentLanguages(languages, subtitles) {
    return differenceWith(languages, subtitles, this.languageExists);
  }

  languageExists = (a, b) => a === b.languageCode;
}

export default new SubtitleStore();
